import React, { useEffect, useState } from 'react';
import { Box, MenuItem, Select, SxProps, Theme } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TaxGroup, useTaxGroups } from '@/core';

type FormDropdownMenuDphCounterControllerProps = {
  controllerName: string;
  dropdownOnChange?: () => void;
  preSelectedTaxValue?: number | string;
  sx?: SxProps<Theme>;
};

export const FormDropdownMenuDphCounterController = ({
  controllerName,
  dropdownOnChange,
  preSelectedTaxValue,
  sx,
}: FormDropdownMenuDphCounterControllerProps) => {
  const { t } = useTranslation();
  const { data: taxGroups } = useTaxGroups();
  const { control, watch, setValue } = useFormContext();
  const totalPrice = watch('price');
  const [selectedTaxGroup, setSelectedTaxGroup] = useState<TaxGroup | undefined>(undefined);

  useEffect(() => {
    if (taxGroups && taxGroups.length > 0) {
      const lastTaxGroup = taxGroups[taxGroups.length - 1];
      const taxGroup = taxGroups.find((g) => g.value === preSelectedTaxValue) || lastTaxGroup;
      setSelectedTaxGroup(taxGroup);
      setValue('tax_group', taxGroup);
      setValue('tax_id', lastTaxGroup.id);
    }
  }, [preSelectedTaxValue, setValue, taxGroups]);

  const handleTaxGroupChange = (taxGroupId: number) => {
    if (!taxGroups) return;
    const taxGroup = taxGroups.find((g) => g.id === taxGroupId) || taxGroups[taxGroups.length - 1];
    const basePrice = Number(totalPrice) / (Number(taxGroup.value) / 100 + 1);
    setValue('base_price', basePrice.toFixed(3).toString().replace(/\.0+$/, ''));
    setValue('tax_group', taxGroup);
    setSelectedTaxGroup(taxGroup);
  };

  return (
    <Controller
      name={controllerName}
      control={control}
      render={({ field }) => (
        <Box sx={{ width: '100%', ...sx }}>
          <Select
            {...field}
            value={selectedTaxGroup?.id ?? ''}
            onChange={(e) => {
              const taxGroupId = Number(e.target.value);
              handleTaxGroupChange(taxGroupId);
              field.onChange(taxGroupId);
              dropdownOnChange?.();
            }}
            fullWidth
          >
            {taxGroups?.map((group) => (
              <MenuItem key={group.id} value={group.id}>
                {group.value}
                {t('PRODUCT.TAX_PERCENT_SUFFIX')}
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}
    />
  );
};
